import { apiClient } from '../config'

export interface CustdevAudienceRules {
  minDaysSinceFirstLaunch: number
  maxDaysSinceFirstLaunch: number | null
  minAppLaunches: number
  maxAppLaunches: number | null
  minAppVersion: string
  maxAppVersion: string | null
  adNameContainsAny: string[]
  bookingUrl: string
  audiences?: { powerUsers: boolean; pelvicAds: boolean; addonBuyers: boolean } | null
  campaignId?: string | null
}

export interface CustdevSettings {
  revision: number
  experienceCallEnabled: boolean
  rules: CustdevAudienceRules
}

export const custdevService = {
  get: async (): Promise<CustdevSettings> => {
    const response = await apiClient.get<CustdevSettings>('/admin/settings/custdev')
    return response.data
  },
  update: async (settings: Omit<CustdevSettings, 'revision'>, expectedRevision: number): Promise<CustdevSettings> => {
    const response = await apiClient.put<CustdevSettings>('/admin/settings/custdev', { ...settings, expectedRevision })
    return response.data
  },
}
